import Icon from '../components/Icon.vue'

Icon.register({
  'meh-rolling-eyes': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM88 224C88 199.7 101.7 178.8 121.6 168 120.9 170.6 120 173.2 120 176 120 193.7 134.3 208 152 208S184 193.7 184 176C184 173.2 183.1 170.6 182.4 168 202.3 178.8 216 199.7 216 224 216 259.3 187.3 288 152 288S88 259.3 88 224zM312 400H184C162.8 400 162.8 368 184 368H312C333.2 368 333.2 400 312 400zM344 288C308.7 288 280 259.3 280 224 280 199.7 293.7 178.8 313.6 168 312.9 170.6 312 173.2 312 176 312 193.7 326.3 208 344 208S376 193.7 376 176C376 173.2 375.1 170.6 374.4 168 394.3 178.8 408 199.7 408 224 408 259.3 379.3 288 344 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/meh-rolling-eyes.js
// module id = mPu1
// module chunks = 144